import { supabase } from '@/lib/supabase'

export interface InviteUserPayload {
  email: string
  roleId: string
  franchiseRegions: string[]
  message?: string
}

export async function inviteUser({ email, roleId, franchiseRegions, message }: InviteUserPayload) {
  const { data, error } = await supabase.functions.invoke('invite-user', {
    body: {
      email,
      role_id: roleId,
      franchise_regions: franchiseRegions,
      message: message?.trim() || undefined
    }
  })

  if (error) throw error
  return data
}
